<template>
<v-container fluid class="fade-in mx-5">
	<v-layout row wrap>
		<v-flex xs12>
         <v-row>
            <v-col xs="12" center class="pt-2 pb-0">
              <h1>Org List - Organization Search</h1>
            </v-col>

          </v-row>
					<v-layout row wrap class="py-2">
						<v-flex xs10>
							<v-text-field
								id="search-field"
								v-model="value"
								label="Type an organization name or code"
								prepend-inner-icon="search"
								persistent-hint
								hint="Min 3 characters to start search"
								clearable>
							</v-text-field>
						</v-flex>

					</v-layout>
					<v-data-table
						:headers="headers"
						:items="organizationList"
						:loading="loading"
						item-key="organizationFice"
						loading-text="Loading... Please wait"
						class="elevation-1 mx-5">
						<template v-slot:item.action="{ item }">
							<v-icon
								class="mr-2 green--text"
								@click="addClick(item)">
								mdi-plus-circle
							</v-icon>
						</template>
						<template #item.organizationFicePFice = {value} >
              				<a href="#" @click="onAddNewOrganization(value,false);">View</a>
						</template>
					</v-data-table>
					<p><v-btn class="primary" @click="onAddNewOrganization(organizationName,true)">Add New Organization</v-btn></p>
					<v-snackbar
						v-model="snackbar"
						:top="true"
						:color="snackColor"
					>
						{{ snackMessage }}
						<v-btn
							dark
							text
							@click="closeSnack()"
						>
						</v-btn>
					</v-snackbar>
					<!--Model popup window to add Office-->
              <div>
                <b-modal size="xl"  ref="my-modal" hide-footer v-model="addorupdateflag" :title="headingtitle" :no-close-on-backdrop="true" :no-close-on-esc="true">
                  <div>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <b-container fluid>
                        <b-row class="mb-1">
							<b-col cols="3">Organization Status<span style="color:red">*</span></b-col>
								<b-col cols="3" style="width:40%">
									<select v-model="addOrg.isActive" class="form-control" required>
										<option value="true" selected>Active</option>
										<option value="false">InActive</option>
									</select>
								</b-col>
							<b-col cols="1"></b-col>
                          	<b-col cols="3"></b-col>
                        </b-row>
						<b-row class="mb-1">
							<b-col cols="3">Organization code <span style="color:red">*</span></b-col>
                         	 <b-col>
                            	<v-text-field v-model="addOrg.organizationFice" label="Organization code" required :rules="organizationFiceRule" :disabled="disableFlag" type="number" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "6"></v-text-field>
                          	</b-col>
                          	<b-col cols="3">Organization Pfice code <span style="color:red">*</span></b-col>
                          	<b-col>
                            	<v-text-field v-model="addOrg.organizationPFice" label="Organization Pfice code" required :rules="organizationPFiceRule" :disabled="disableFlag" type="number" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "6"></v-text-field>
                          	</b-col>
                        </b-row>
						<b-row class="mb-1">
                          <b-col cols="3">Organization Name <span style="color:red">*</span></b-col>
                          <b-col>
                            <v-text-field v-model="addOrg.organizationName" label="Organization Name" required :rules="organizationNameRule" type="text" maxlength="250"></v-text-field>
                          </b-col>
						  <b-col cols="3">Organization Short Name <span style="color:red">*</span></b-col>
                          <b-col>
                            <v-text-field v-model="addOrg.organizationShortName" maxlength="250" label="Organization Short Name" required :rules="organizationShortNameRule" type="text"></v-text-field>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">Organization Type <span style="color:red">*</span></b-col>
                          <b-col cols="3" style="width:65%">
                            <select v-model="addOrg.organizationType" class="form-control" required :rules="organizationTypeRule">
                              <option value="null" selected>Select</option>
                              <option value="1">Academic Institution (A)</option>
							  <option value="4">Nonprofit Institution (N)</option>
							  <option value="6">Academic Consortium (AC)</option>
							  <option value="7">Nonprofit Consortium (NC)</option>
                            </select>
                          </b-col>
						  <b-col cols="3">Address </b-col>
                          <b-col>
                            <input v-model="addOrg.address" label="Address" type="text" class="form-control" id="address" name="address" maxlength="150"/>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">City </b-col>
                          <b-col>
                            <input v-model="addOrg.city" label="City" type="text" class="form-control" id="city" name="city"/>
                          </b-col>
								<b-col cols="3">State <span style="color:red">*</span></b-col>
								<b-col cols="3" style="width:30%">
								<select v-model="addOrg.state" class="form-control" required :rules="stateRule">
									<option value="null" selected>Select</option>
									<option value="AL">Alabama (AL)</option>
									<option value="AK">Alaska (AK)</option>
									<option value="AZ">Arizona (AZ) </option>
									<option value="AR">Arkansas (AR) </option>
									<option value="CA">California (CA) </option>
									<option value="CO">Colorado (CO) </option>
									<option value="CT">Connecticut (CT) </option>
									<option value="DE">Delaware (DE) </option>
									<option value="DC">District of Columbia (DC) </option>
									<option value="FL">Florida (FL) </option>
									<option value="GA">Georgia (GA) </option>
									<option value="HI">Hawaii (HI) </option>
									<option value="ID">Idaho (ID) </option>
									<option value="IL">Illinois (IL) </option>
									<option value="IN">Indiana (IN) </option>
									<option value="IA">Iowa (IA) </option>
									<option value="KS">Kansas (KS) </option>
									<option value="KY">Kentucky (KY) </option>
									<option value="LA">Louisiana (LA) </option>
									<option value="ME">Maine (ME) </option>
									<option value="MD">Maryland (MD) </option>
									<option value="MA">Massachusetts (MA) </option>
									<option value="MI">Michigan (MI) </option>
									<option value="MN">Minnesota (MN) </option>
									<option value="MS">Mississippi (MS) </option>
									<option value="MO">Missouri (MO) </option>
									<option value="MT">Montana (MT) </option>
									<option value="NE">Nebraska (NE) </option>
									<option value="NV">Nevada (NV) </option>
									<option value="NH">New Hampshire (NH) </option>
									<option value="NJ">New Jersey (NJ) </option>
									<option value="NM">New Mexico (NM) </option>
									<option value="NY">New York (NY) </option>
									<option value="NC">North Carolina (NC) </option>
									<option value="ND">North Dakota (ND) </option>
									<option value="OH">Ohio (OH) </option>
									<option value="OK">Oklahoma (OK) </option>
									<option value="OR">Oregon (OR) </option>
									<option value="PA">Pennsylvania (PA) </option>
									<option value="RI">Rhode Island (RI) </option>
									<option value="SC">South Carolina (SC)</option>
									<option value="SD">South Dakota (SD) </option>
									<option value="TN">Tennessee (TN) </option>
									<option value="TX">Texas (TX) </option>
									<option value="UT">Utah (UT) </option>
									<option value="VT">Vermont (VT)</option>
									<option value="VA">Virginia (VA) </option>
									<option value="WA">Washington (WA) </option>
									<option value="WV">West Virginia (WV) </option>
									<option value="WI">Wisconsin (WI) </option>
									<option value="WY">Wyoming (WY) </option>
									<option value="PR">Puerto Rico (PR) </option>
									<option value="OO">Other U. S. territories (OO) </option>
								</select>
								</b-col>
                        </b-row>
						<b-row class="mb-1">
                          <b-col cols="3">Zip</b-col>
                          <b-col>
                            <input v-model="addOrg.zip" label="Zip" class="form-control" id="zip" name="zip" type="number" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "6"/>
                          </b-col>
                          <b-col cols="3">Phone </b-col>
                          <b-col>
                            <input v-model="addOrg.phone" label="Phone" type="number" class="form-control" id="phone" name="phone" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "10"/>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">HBCU </b-col>
                          <b-col>
						  	<select v-model="addOrg.hbcu" class="form-control">
                              <option value="0" selected>0</option>
							  <option value="1" selected>1</option>
                            </select>
                          </b-col>
                          <b-col cols="3">HDG </b-col>
                          <b-col>
						  	<select v-model="addOrg.hdg" class="form-control">
                              <option value="0">0</option>
							  <option value="1" selected>1</option>
                            </select>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">NPtype </b-col>
                          <b-col>
						  	<select v-model="addOrg.nptype" class="form-control">
                              <option value="0">0</option>
							  <option value="1" selected>1</option>
                            </select>
                          </b-col>
                          <b-col cols="3">Type of Control </b-col>
                          <b-col>
						  	<select v-model="addOrg.toc" class="form-control">
                              <option value="0">0</option>
							  <option value="1" selected>1</option>
                            </select>
                          </b-col>
                        </b-row>
                         <b-row class="mb-1">
                          <b-col cols="3">Inst Lvl</b-col>
                          <b-col>
						  	<select v-model="addOrg.instLvl" class="form-control">
                              <option value="0">0</option>
							  <option value="1" selected>1</option>
                            </select>
                          </b-col>
                          <b-col cols="3">Campusseq</b-col>
                          <b-col>
						  	<select v-model="addOrg.campusseq" class="form-control">
                              <option value="0">0</option>
							  <option value="1" selected>1</option>
                            </select>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">Carncode</b-col>
                          <b-col>
						  	<select v-model="addOrg.carncode" class="form-control">
                              <option value="0">0</option>
							  <option value="1" selected>1</option>
                            </select>
						  </b-col>
							<b-col cols="3">HHE</b-col>
						  <b-col>
						  	<select v-model="addOrg.hhe" class="form-control">
                              <option value="0">0</option>
							  <option value="1" selected>1</option>
                            </select>
                          </b-col>
                        </b-row>
						<b-row class="mb-1">
                          <b-col cols="3">Tribal </b-col>
                          <b-col>
						  	<select v-model="addOrg.tribal" class="form-control">
                              <option value="0">0</option>
							  <option value="1" selected>1</option>
                            </select>
                          </b-col>
                          <b-col cols="3">Minority</b-col>
                          <b-col>
						  	<select v-model="addOrg.minority" class="form-control">
                              <option value="0">0</option>
							  <option value="1" selected>1</option>
                            </select>
						  </b-col>
                        </b-row>
						<b-row class="mb-1">
						  <b-col cols="3">Sysflag</b-col>
						  <b-col>
						  	<select v-model="addOrg.sysflag" class="form-control">
                              <option value="0">False</option>
							  <option value="1" selected>True</option>
                            </select>
                          </b-col>
                          <b-col cols="3">System</b-col>
                          <b-col>
														<input v-model="addOrg.system" type="number" class="form-control" id="system" name ="system" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "3"/>
                          </b-col>
                        </b-row>
						<b-row class="mb-1">
						  <b-col cols="3">WebAddress</b-col>
                          <b-col>
                            <input v-model="addOrg.webAddress" type="text" class="form-control" id="webAddress" name="webAddress" maxlength="150"/>
                          </b-col>
						  <b-col cols="3">Comments</b-col>
						  <b-col>
						  	<textarea v-model="addOrg.comments" rows="5" cols="60" placeholder="Enter text" class="form-control" name="comments" :min-height="200"
								:max-height="400"></textarea>
						  </b-col>
						</b-row>
						<b-row class="mb-1">
						  <b-col cols="3">DstShortName</b-col>
						  <b-col>
                            <input v-model="addOrg.dstSorterName" type="text" class="form-control" id="dstSorterName" name ="dstSorterName"/>
                          </b-col>
						  <b-col cols="3">DstName</b-col>
                          <b-col>
                            <input v-model="addOrg.dstName" type="text" class="form-control" id="dstName" name="dstName" />
                          </b-col>
                        </b-row>
						<b-row class="mb-1">
                          <b-col cols="3">UnitId</b-col>
                          <b-col>
                            <input v-model="addOrg.unitId" type="number" class="form-control" id="unitid" name ="unitid" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "6"/>
						  </b-col>
							<b-col cols="3" style="display: none">Version <span style="color:red">*</span></b-col>
						  <b-col style="display: none">
								<v-text-field v-model="addOrg.version" value="1" label="Version" required :rules="versionRule" type="number" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "2"></v-text-field>
                          </b-col>
                        </b-row>
		  				<b-row class="mb-1">
                          <b-col cols="3">StyleGuideReviewCompleted</b-col>
                          <b-col>
                            <input v-model="addOrg.styleGuideReviewCompleted" type="number" class="form-control" id="styleGuideReviewCompleted" name="styleGuideReviewCompleted" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "1"/>
                          </b-col>
                          <b-col cols="3">StyleGuideReviewCompletedDate</b-col>
                          <b-col>
														<v-text-field :class="txtDisplay" v-model="addOrg.styleGuideReviewCompletedDate" value="1" type="text" :disabled="disableFlag"></v-text-field>
						  	<input v-model="addOrg.styleGuideReviewCompletedDate" type="date" id="styleGuideReviewCompletedDate" name="styleGuideReviewCompletedDate" min="1900-01-01" max="2100-12-31" :class="dtDisplay" class="form-control"/>
						  </b-col>
                        </b-row>
						<b-row class="mb-1">
						  <b-col cols="3">HAIE</b-col>
						  <b-col>
                            	<input v-model="addOrg.haie" type="number" class="form-control" id="haie" name ="haie" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "6"/>
                          </b-col>
						  <b-col cols="3">CleanupCode</b-col>
                          <b-col>
                            <input v-model="addOrg.cleanupcode" type="number" class="form-control" id="cleanupcode" name="cleanupcode"  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "6"/>
                          </b-col>
						</b-row>
		  				<b-row class="mb-1">
                          <b-col cols="3">LastFyFunded</b-col>
                          <b-col>
                            <input v-model="addOrg.lastFyFunded" class="form-control" id="lastFyFunded" name ="lastFyFunded" type="number" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "4"/>
						  </b-col>
							<b-col cols="3">Closed</b-col>
						  <b-col>
						  		<select v-model="addOrg.closed" class="form-control" required>
										<option value="0" selected>No</option>
										<option value="1">Yes</option>
								</select>
                          </b-col>
                        </b-row>
						<b-row class="mb-1">
							<b-col cols="3">EIN</b-col>
						  <b-col>
                            	<input v-model="addOrg.ein" type="text" class="form-control" id="ein" name ="ein" maxlength="50"/>
                          </b-col>
						</b-row>
                      </b-container>
											<b-row class="mb-1">
                      <b-button class="form-button" :loading="isLoading" v-model="headingtitle" block @click="onSaveOrganization(headingtitle)">Save</b-button>
											&nbsp;
											<b-button class="form-button" @click="onCancel()">Cancel</b-button>
											&nbsp;<span style="color:blue;">{{message}}</span>
									</b-row>
                    </v-form>
                   </div>
                </b-modal>
              </div>
		</v-flex>
	</v-layout>
  </v-container>
</template>

<script>
import { lookUpService } from "../../services/lookUpService";
import { surveyService } from "@/services/surveyService.js";

export default {
  name: "AdminCodeBookSearch",
  props: {
		snackMessage: String,
		snackbarHolder: Boolean,
		snackColor: String,
		disabled: Boolean
  },
	data: () => ({
		txtDisplay: null,
		dialogHolder: false,
		notifications: false,
		sound: true,
			widgets: false,
			value: null,
			loading: false,
			headers: [
			{ text: 'View', value: 'organizationFicePFice' },
			{ text: 'Organization code', value: 'organizationFice' },
			{ text: 'Organization Pfice', value: 'organizationPfice' },
			{ text: 'Name', value: 'organizationName' },
			{ text: 'OrganizationShortName', value: 'organizationShortName' },
			{ text: 'State', value: 'state' },
			{ text: 'City', value: 'city' },
			{ text: 'Type', value: 'organizationTypeCode' },
			{ text: 'Status', value: 'status' }
		],
		organizationList: [],
		organizationFiceRule: [v => !!v || 'Organization code is required',
		v => (v && v.length <= 10) || 'Organization code must be less than or equal to 6 characters'],
        organizationPFiceRule: [v => !!v || 'Suborganization code is required',
        v => (v && v.length <= 6) || 'Suborganization code must be less than or equal to 6 characters'],
        organizationNameRule: [v => !!v || 'Organization Name is required'],
        organizationShortNameRule: [v => !!v || 'Organization ShortName is required'],
        organizationTypeRule: [v => !!v || 'Organization Type is required'],
				stateRule: [v => !!v || 'State is required'],
				versionRule: [v => !!v || 'Version is required'],
		message: '',
		headingtitle: '',
		disableFlag: null,
		isLoading: null,
		addorupdateflag: null,
    addOrg: {
		isActive: Boolean,
		organizationFicePFice: null,
		organizationFice: null,
		organizationPFice: null,
		organizationName: null,
		organizationShortName: null,
		organizationType: null,
		address: null,
		city: null,
		state: null,
		zip: null,
		phone: null,
		hbcu: "0",
		hdg: "0",
		nptype: "0",
		toc: "0",
		instLvl: "0",
		campusseq: "0",
		carncode: "0",
		hhe: "0",
		tribal: "0",
		minority: "0",
		system: null,
		sysflag: "0",
		webAddress: null,
		comments: null,
		dstSorterName: null,
		dstName: null,
		unitId: null,
		version: 1,
		styleGuideReviewCompleted: null,
		styleGuideReviewCompletedDate: null,
		haie: null,
		cleanupcode: null,
		lastFyFunded: null,
		closed: "0",
		ein: null,
		View: null
    }
	}),
	methods: {
		onCancel () {
			this.$refs['my-modal'].hide();
		},
		addClick (item) {
		this.$emit('addClick', {
    code: item.organizationFicePFice,
		name: item.organizationName,
		type: item.organizationType
    });
		},
		closeSnack () {
			this.$emit('closeSnack')
		},
		saveChanges () {
			debugger;
			this.$store.commit('setIsLoading', { isLoading: true });
			this.$emit('save');
		},
		onAddNewOrganization (organizationName, flag)	{
		  	const me = this;
        me.addorupdateflag = flag;
        if (organizationName != null && !flag) {
            me.headingtitle = "Update Organization";
						surveyService.getOrganization(organizationName).then(function (response) {
						if (response && response.data) {
							debugger;
							me.message = "";
							me.dtDisplay = "btnDisplay";
							me.txtDisplay = "";
							me.disableFlag = true;
							me.addOrg.isActive = response.data.organization.isActive;
							me.addOrg.organizationFice = response.data.organizationFice;
							me.addOrg.organizationPFice = response.data.organizationPfice;
							me.addOrg.organizationName = response.data.organization.organizationName;
							me.addOrg.organizationShortName = response.data.organization.organizationShortName;
							me.addOrg.organizationType = response.data.organization.organizationTypeCode;
							me.addOrg.address = response.data.address;
							me.addOrg.city = response.data.city;
							me.addOrg.state = response.data.state;
							me.addOrg.zip = response.data.zip;
							me.addOrg.phone = response.data.phone;
							me.addOrg.hbcu = response.data.hbcu;
							me.addOrg.hdg = response.data.hdg;
							me.addOrg.nptype = response.data.npType;
							me.addOrg.toc = response.data.toc;
							me.addOrg.instLvl = response.data.instLvl;
							me.addOrg.campusseq = response.data.campusSeq;
							me.addOrg.carncode = response.data.carnCode;
							me.addOrg.hhe = response.data.hhe;
							me.addOrg.tribal = response.data.tribal;
							me.addOrg.minority = response.data.minority;
							me.addOrg.system = response.data.system;
							me.addOrg.sysflag = response.data.sysFlag;
							me.addOrg.webAddress = response.data.webAddress;
							me.addOrg.comments = response.data.comments;
							me.addOrg.dstSorterName = response.data.dstSorterName;
							me.addOrg.dstName = response.data.dstName;
							me.addOrg.unitId = response.data.unitId;
							me.addOrg.version = response.data.version;
							me.addOrg.styleGuideReviewCompleted = response.data.styleGuideReviewCompleted;
							const dateString = response.data.styleGuideReviewCompletedDate;
							const date = new Date(dateString);
							const dateFormatted = new Intl.DateTimeFormat("en-US", { year: "numeric", month: "2-digit",	day: "2-digit" }).format(date);
  						me.addOrg.styleGuideReviewCompletedDate = dateFormatted;
							me.addOrg.haie = response.data.haie;
							me.addOrg.cleanupcode = response.data.cleanupCode;
							me.addOrg.lastFyFunded = response.data.lastFyFunded;
							me.addOrg.closed = response.data.closed;
							me.addOrg.ein = response.data.ein;
						}
					});
				} else {
					  me.dtDisplay = "";
					  me.txtDisplay = "btnDisplay";
            me.disableFlag = false;
						me.addOrg.isActive = true;
            me.addOrg.organizationFice = null;
						me.addOrg.organizationPFice = null;
            me.addOrg.organizationName = null;
            me.addOrg.organizationShortName = null;
            me.addOrg.organizationType = null;
            me.addOrg.address = null;
            me.addOrg.city = null;
            me.addOrg.state = null;
            me.addOrg.zip = null;
            me.addOrg.phone = null;
            me.addOrg.hbcu = "0";
            me.addOrg.hdg = "0";
            me.addOrg.nptype = "0";
            me.addOrg.toc = "0";
            me.addOrg.instLvl = "0";
						me.addOrg.campusseq = "0";
						me.addOrg.carncode = "0";
						me.addOrg.hhe = "0";
						me.addOrg.tribal = "0";
						me.addOrg.minority = "0";
						me.addOrg.system = null;
						me.addOrg.sysflag = "0";
						me.addOrg.webAddress = null;
						me.addOrg.comments = null;
						me.addOrg.dstSorterName = null;
						me.addOrg.dstName = null;
						me.addOrg.unitId = null;
						me.addOrg.version = 1;
						me.addOrg.styleGuideReviewCompleted = null;
						me.addOrg.styleGuideReviewCompletedDate = null;
						me.addOrg.haie = null;
						me.addOrg.cleanupcode = null;
						me.addOrg.lastFyFunded = null;
						me.addOrg.closed = "0";
						me.addOrg.ein = null;
						me.headingtitle = "Add New Organization";
          }
			this.$refs['my-modal'].show();
		},
		onSaveOrganization (headingtitle) {
			debugger;
			const me = this;
			me.message = "Processing please wait..";
			var flag = true;
			if (me.headingtitle === "Add New Organization") {
				flag = true;
						if (me.$refs.form.validate())	{
									if (me.addOrg.state == null || me.addOrg.organizationType == null) {
										me.message = "State or Organization type may not be selected.";
										me.isLoading = false;
										return false;
									}
					}
			} else {
				flag = false;
			}
				me.isLoading = true;
				surveyService.saveOrganization(me.addOrg.isActive, me.addOrg.organizationFice, me.addOrg.organizationPFice, me.addOrg.organizationName, me.addOrg.organizationShortName, me.addOrg.organizationType, me.addOrg.address, me.addOrg.city, me.addOrg.state, me.addOrg.zip,
				me.addOrg.phone, me.addOrg.hbcu, me.addOrg.hdg, me.addOrg.nptype, me.addOrg.toc, me.addOrg.instLvl, me.addOrg.campusseq, me.addOrg.carncode, me.addOrg.hhe, me.addOrg.tribal, me.addOrg.minority, me.addOrg.system, me.addOrg.sysflag, me.addOrg.webAddress, me.addOrg.comments, me.addOrg.dstSorterName, me.addOrg.dstName,
				me.addOrg.unitId, me.addOrg.version, me.addOrg.styleGuideReviewCompleted, me.addOrg.styleGuideReviewCompletedDate, me.addOrg.haie, me.addOrg.cleanupcode, me.addOrg.lastFyFunded, me.addOrg.closed, me.addOrg.ein, flag)
				.then(function (response) {
					if (response.data === "Successfully saved") {
						me.isLoading = false;
						me.message = response.data;
						//me.onload(document.getElementById('search-field').value);
					} else {
						me.isLoading = false;
						me.message = response.data;
					}
				})
				.catch(function (response) {
					me.message = "Error occured: " + response;
					me.isLoading = false;
			});
		},
		onload (requestBody) {
			const me = this;
			debugger;
			lookUpService.searchOrganizationsAny(requestBody).then(function (response) {
				if (response && response.data.results) {
					for (var i = 0; i < response.data.results.length; i++) {
						if (response.data.results[i].isActive == true) {
							response.data.results[i].status = 'Active';
						} else {
							response.data.results[i].status = 'InActive';
						}
						response.data.results[i].organizationFicePFice = response.data.results[i].organizationFice + '-' + response.data.results[i].organizationPfice;
					}
					me.organizationList = response.data.results;
					me.loading = false;
				}
			})
			.catch(function (e) {
				console.log(e);
				throw e;
			});
		}
	},
	watch: {
		value: function (newVal, oldVal) {
			if (newVal && newVal.length > 2) {
				this.loading = true;
				var requestBody = {
					search: newVal
				}
				const me = this;
				lookUpService.searchOrganizationsAny(requestBody).then(function (response) {
				if (response && response.data.results) {
					for (var i = 0; i < response.data.results.length; i++) {
						if (response.data.results[i].isActive == true) {
							response.data.results[i].status = 'Active';
						} else {
							response.data.results[i].status = 'InActive';
						}
						response.data.results[i].organizationFicePFice = response.data.results[i].organizationFice + '-' + response.data.results[i].organizationPfice;
					}
					me.organizationList = response.data.results;
					me.loading = false;
				}
			})
			.catch(function (e) {
				console.log(e);
				throw e;
			});
			} else {
				this.organizationList = [];
			}
		}
	},
	computed: {
		dialog: {
			get: function () {
				return this.dialogHolder;
			},
			set: function (newVal) {
				var navTop = document.getElementById("survey-nav");

				if (newVal) {
					navTop.classList.add("fullscreen");
				} else {
					navTop.classList.remove("fullscreen");
				}
				this.dialogHolder = newVal;
			}
		},
		snackbar: {
			get: function () {
				return this.snackbarHolder;
			},
			set: function (newVal) {
				this.closeSnack();
			}
		}
	},
  mounted () {

	}
};
</script>

<style scoped>
.row-label {
	/*GBC line-height: 48px;*/
	font-weight: bold;
	text-align: left;
}
.row-label-sub {
	font-weight: normal;
	text-align: left;
	margin-top: 10px;
	margin-left: 5%;
}
.row-label-help {
	font-weight: normal;
	text-align: left;
	margin-left: 25px;
}

.bg-light-blue {
	background-color: #d9e2f3 !important; /* have to force it on this page but not globally so local to page */
}

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn-outlined) {
  color: grey !important;
	background: #cfdbf1 !important;
}
.btnDisplay {
  display: none;
}
</style>
